// src/components/MenuBar.jsx
import { useNavigate } from "react-router-dom";
import { useI18n } from "./i18n/I18nContext";
import "./MenuExact.css";

export default function MenuBar({ active }) {
  const { t } = useI18n();

  const navigate = useNavigate();
  return (
    <div
      style={{
        background: "#000",
        color: "#fff",
        padding: "20px 16px 0",
      }}
    >
      <div className="logo logo-responsive">
        <div className="logo-title">WOODOO</div>
        <div className="logo-sub">AUGMENTED WOOD</div>
      </div>

      <div className="tabs tabs-responsive">
        <button
          className={`tab tab-responsive ${active === "logistique" ? "tab-active" : ""}`}
          onClick={() => navigate("/menu")}
        >
          {t("nav.logistique")}
        </button>
        <button
          className={`tab tab-responsive ${active === "production" ? "tab-active" : ""}`}
          onClick={() => navigate("/menu")}
        >
          {t("nav.production")}
        </button>
        <button
          className={`tab tab-responsive ${active === "qualite" ? "tab-active" : ""}`}
          onClick={() => navigate("/menu")}
        >
          {t("nav.qualite")}
        </button>
        <button
          className={`tab tab-responsive ${active === "rd" ? "tab-active" : ""}`}
          onClick={() => navigate("/menu")}
        >
          {t("nav.rd")}
        </button>

        <button
          className={`tab tab-responsive ${active === "dashboard" ? "tab-active" : ""}`}
          onClick={() => navigate("/dashboard")}
        >
          {t("nav.dashboard")}
        </button>
      </div>

      <hr className="divider" />
    </div>
  );
}
